import { COLORS } from "../../../../theme/colors";

export function getPowerAssetsGroupColor(powerAssetsGroupType) {
  switch (powerAssetsGroupType) {
    case "batteries":
      return COLORS.majorelleBlue;
    case "solar":
      return COLORS.mikadoYellow;
    case "ev":
      return COLORS.cian;
    default:
      return COLORS.grey;
  }
}
